import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import routes from "./config/routes"; //no se pone {} porque se esportó de manera default
import "./App.scss";
import AuthProvider from "./providers/AuthProvider";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Switch>
          {routes.map((route, index) => (
            <RouteWithSubRoutes key={index} {...route} />
          ))}
          {/*... route traera todo el objeto*/}
        </Switch>
      </Router>
    </AuthProvider>
  );
}
//funcion tipo componente "function RouterWhitSubru"
//funcion tipo hook "function useState"
//funcion normal "function transformData"
function RouteWithSubRoutes(route) {
  //recibe la ruta correspondiente
  //funcion que se encarga de renderizar la ruta padre a las rutas hijas el componente
  //al LayoutAdmin se le pasaran todas las rutas
  //linea 35 =route(el parametro de la funcion).path "/admin" (LayoutAdmin-panel de control)
  //linea 36 = route.exact(En routes.js/LayoutAdmin está como false)
  //*render(renderiza 1 componente y añadir mas cosas) y component(renderiza 1 componente)*
  //route.component(renderizar el LayoutAdmin) linea 35
  //36 se añade la ruta de /admin/login desde "routes={}{...props}se mandan todos los props"
  return (
    <Route
      path={route.path}
      exact={route.exact}
      render={(props) => <route.component routes={route.routes} {...props} />}
    />
  );
}
export default App;
